(function () {
  'use strict';

  angular.module('gallery.upload').factory('GalleryUpload', GalleryUpload);

  GalleryUpload.$inject = ['$resource'];

  function GalleryUpload($resource) {
    return $resource(
      '/api/',
      {},
      {
        houseImages: {
          method: 'GET',
          url: '/api/house/:id/image',
          isArray: true,
        },
        naviHouseSource: {
          method: 'GET',
          url: '/api/house/:id/image/source',
          isArray: true,
        },
        naviHouseDraft: {
          method: 'GET',
          url: '/api/house/:id/image/draft',
          isArray: true,
        },
        naviHousePreview: {
          method: 'GET',
          url: '/api/house/:id/image/preview',
          isArray: true,
        },
        naviSectionSource: {
          method: 'GET',
          url: '/api/section/:id/image/source',
          isArray: true,
        },
        naviSectionPreview: {
          method: 'GET',
          url: '/api/section/:id/image/preview',
          isArray: true,
        },
      },
    );
  }
})();
